import { TableHead, TableRow } from "@material-ui/core";
import React from "react";
import StyledTableCell from "../../../styles/tableCell";

export default function TableHeadGuarantee({ showSites }) {
  return (
    <TableHead>
      <TableRow
        style={{
          borderBottom: "0.5px solid gray",
        }}
      >
        <StyledTableCell align="center">Service ticket</StyledTableCell>
        {showSites && (
          <StyledTableCell align="center">Sucursal</StyledTableCell>
        )}
        <StyledTableCell align="center">Tipo de producto</StyledTableCell>
        <StyledTableCell align="center">IMEI</StyledTableCell>
        <StyledTableCell align="center">Cliente</StyledTableCell>
        <StyledTableCell align="center">Marca-Modelo</StyledTableCell>
        <StyledTableCell align="center">Falla</StyledTableCell>
        <StyledTableCell align="center">Estatus</StyledTableCell>
        <StyledTableCell align="center">Tipificación</StyledTableCell>
        <StyledTableCell align="center">Fecha de alta</StyledTableCell>
      </TableRow>
    </TableHead>
  );
}
